import { useEffect, useRef, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Form, Space } from 'antd'
import { useForm } from "antd/lib/form/Form"
import { axiosHandleEvent, baseAxiosNoInfo } from "../../tool/axios"
import { SelectGoodsByType } from "../../component/common/Selects"
import ProductSpecsDetail from '../../component/mall/ProductSpecsDetail'
import _ from 'lodash'

export default function () {

    const { id }: { id: string | undefined } = useParams()
    const [pageTitle, setPageTitle] = useState<string>('')

    const [goodsID, setGoodsID] = useState<string>('')
    const [goodsData, setGoodsData] = useState<{ spuID: string | undefined, goodsStandardData: editStandardsParams[] }>({ spuID: undefined, goodsStandardData: [] })
    const [form] = useForm()

    const standardsDetailRef = useRef<any>()

    type editStandardsParams = {
        id?: string | undefined,
        goods_specs_ids: string,
        goods_specs_names: string,
        goods_specs_values: string,
        sku_code: string,
        sku_pic_url: string,
        inventory_num: number,
        sale_price: number,
        your_price: number
    }

    useEffect(() => {
        if (id) {
            baseAxiosNoInfo('/mall_center/sku/detail', { params: { sku_id: id } }).then((res: any) => {
                if (res) {
                    let data: any = {}

                    for (let attr in res) {
                        if (attr !== 'goods_type_id' && attr !== 'goods_spu_id') data[attr] = res[attr]
                    }

                    form.setFieldsValue({
                        ids: {
                            goodsID: res.goods_spu_id,
                            typeID: res.goods_type_id
                        },

                        goods_specs_arr: [data]
                    })
                }
            })

            setPageTitle('编辑商品规格')

        } else {
            setPageTitle('新增商品规格')
        }
    }, [])

    const checkGoodsSpecsArr = (_: any, value: editStandardsParams[]) => {
        if (!value) {
            return Promise.reject(new Error('商品规格，产品编号，图片，库存，建议售价，划线价不能为空'))
        }

        let baseResut: boolean = value.every((el: editStandardsParams) => {
            return el.goods_specs_ids.length > 0 && el.goods_specs_names.length > 0 && el.goods_specs_values.length > 0 && el.inventory_num > 0 && el.inventory_num.toString().indexOf('.') === -1 && el.sale_price > 0 && el.your_price > 0 && el.sku_code != null && el.sku_pic_url.length > 0
        })


        if (!value || !baseResut) {
            return Promise.reject(new Error('商品规格必须填写完整，库存必须为正整数'))
        }

        let names: string[] = value[0].goods_specs_names.split(',')

        const checkNameCol = () => {
            return names.every(el => el.length > 0)
        }

        const checkValCol = () => {
            return value[0].goods_specs_values.split(',').every(el => el.length > 0)
        }

        const checkNameRepeat = () => {
            let fullLength = names.length
            let setLength = (new Set([...names])).size

            return setLength === fullLength
        }

        // 规格名与规格值的匹配
        const checkValRepeat = () => {
            let valArr: string[] = []
            value.forEach(el => {
                valArr.push(el.goods_specs_values.toString())
            })

            let handleLength: number = new Set([...valArr]).size
            return handleLength === valArr.length
        }

        // 检查规格名下拉菜单是否选中
        let resultNameSelect: boolean = checkNameCol()
        let resultValSelect: boolean = checkValCol()

        // 检查规格名是否重复
        let resultNameRepeat: boolean = checkNameRepeat()
        let resultValRepeat: boolean = checkValRepeat()

        if (!resultNameSelect) {
            return Promise.reject(new Error('规格名必选'))
        }

        if (!resultValSelect) {
            return Promise.reject(new Error('规格值必选'))
        }

        if (!resultNameRepeat) {
            return Promise.reject(new Error('规格名不能重复'))
        }

        if (!resultValRepeat) {
            return Promise.reject(new Error('规格值不能重复'))
        }

        if (resultNameSelect && resultValSelect && resultNameRepeat && resultValRepeat) {
            return Promise.resolve()
        }
    }

    const onFinish = (values: any) => {
        let url = id ? '/mall_center/sku/update' : '/mall_center/sku/add'
        let postData = _.cloneDeep(values)

        postData.goods_type_id = values.ids.typeID
        postData.goods_spu_id = values.ids.goodsID
        delete postData.ids

        axiosHandleEvent.post(url, {
            id,
            ...postData
        })
    }

    return (<div className="common-level2-edit">
        {/* 商城中心 -> 商品管理 -> 商品规格管理 -> 新增或编辑 */}
        <h2>{pageTitle}</h2>

        <div className="common-main">
            <Form form={form} name="basic" onFinish={onFinish} >
                <Form.Item
                    label="商品"
                    name="ids"
                    rules={[{ required: true, message: '选择商品' }]}
                >
                    <SelectGoodsByType showSearch sceneType={2} disabled={id ? true : false} goodsChange={(v: string) => {
                        setGoodsID(v)
                    }} />
                </Form.Item>

                <Form.Item
                    required
                    label="商品规格"
                    name="goods_specs_arr"
                    rules={[{ validator: checkGoodsSpecsArr }]}
                >
                    <ProductSpecsDetail ref={standardsDetailRef} pid={id} spuData={goodsData} spuID={goodsID} />
                </Form.Item>

                <Form.Item>
                    <Space>
                        <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" htmlType="submit">提交</Button>
                        <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>
    </div>)
}